import choosePersonPage from './views/choosePerson.html'

class preWarnSettingCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, globalFn) {
        const typecodeArr = '["compare_type","compare_data_type"]'
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        const pointCode = $state.params.id
        // $scope.titles = {
        //     ivat_invoice_alarm: '本机构获取到的可认证发票的状态发生异常，或超过指定开票时间后还未认证，则进行预警提醒。',
        //     red_invoice_count: '达到各开票点/机构每月已开票总数的指定百分比，或指定数量，则进行预警提醒。按自然月统计，每月最后一天24:00清零。',
        //     abolish_invoice_count: '达到各开票点/机构每月已开票总数的指定百分比，或指定数量，则进行预警提醒。按自然月统计，每月最后一天24:00清零。'
        // }
        console.log(pointCode)
        if (pointCode === 'ivat_invoice_alarm') {
            $scope.title = '本机构获取到的可认证发票的状态发生异常，或超过指定开票时间后还未认证，则进行预警提醒。'
        } else if (pointCode === 'invoice_stock_alarm') {
            $scope.title = ''
        } else if (pointCode === 'equipment_drops_alarm') {
            $scope.title = '当托管设备处于非在线状态，会进行预警提醒。'
        } else {
            $scope.title = '达到各开票点/机构每月已开票总数的指定百分比，或指定数量，则进行预警提醒。按自然月统计，每月最后一天24:00清零。'
        }
        const isPnumReg = /^[\d]{1,2}$/
        let alarmCondition = []
        let makeFieldRule
        $scope.ruleTab = 0
        // 初始化表单数据
        $scope.param = {
            alarmRulesetList: [
                {
                    kpiObject: '',
                    ruleList: [],
                    rulesetName: '告警1',
                },
            ],
            noticeInterval: 0,
            noticeType: '',
            notifierList: [],
            pointCode,
        }

        // 通知方式
        $scope.invoiceType = {
            email: false,
            message: false,
        }
        let invoiceTypeArr = []
        $scope.invoiceTypeChange = function (v, n) {
            // 看数据结构决定
            if (v) {
                invoiceTypeArr.push(n)
            } else {
                invoiceTypeArr.splice(invoiceTypeArr.indexOf(n), 1)
            }
            $scope.param.noticeType = invoiceTypeArr.join(',')
        }
        function deepCopy(target) {
            const result = []
            target.forEach((item) => {
                result.push($.extend(true, {}, item))
            })
            return result
        }
        // 获取已配置数据
        httpRequest.get_qryOrgAlarm({ pointCode }).then((res1) => {
            $scope.param = Object.assign($scope.param, res1.data.value)
            // 通知方式命中
            const invoiceType = $scope.param.noticeType
            invoiceTypeArr = invoiceType.split(',')
            for (const a in $scope.invoiceType) {
                if (invoiceTypeArr.indexOf(a) > -1) {
                    $scope.invoiceType[a] = true
                }
            }
            // 获取类型告警
            httpRequest.get_qryOrgAlarmCondition({ pointCode }).then((res2) => {
                alarmCondition = res2.data.value
                if ($scope.param.alarmRulesetList.length === 0) {
                    $scope.param.alarmRulesetList = [
                        {
                            kpiObject: alarmCondition[0].kpiObject,
                            ruleList: [],
                            rulesetName: '告警1',
                            alarmCondition: deepCopy(alarmCondition),
                        },
                    ]
                } else {
                    $scope.param.alarmRulesetList.forEach((alarmItem) => {
                        // 为每条告警对应一个单独的条件数组，该条件数组用于保存当前的选中状态等
                        // TOBE optimized 由组件生成条件数组的副本
                        alarmItem.alarmCondition = deepCopy(alarmCondition)
                        alarmItem.ruleList.forEach((fieldRule, index) => {
                            alarmItem.alarmCondition.forEach((condition) => {
                                condition.fieldList.forEach((field) => {
                                    // 为每一个预警字段配置候选条件
                                    if (fieldRule.fieldCode === field.fieldCode) {
                                        alarmItem.ruleList[index] = makeFieldRule(fieldRule, field)
                                        field.selected = true
                                    }
                                })
                            })
                        })
                    })
                }
            })
        })

        // kpi指标变化，重置条件
        $scope.kpiObjectChange = function () {
            $scope.param.alarmRulesetList[$scope.ruleTab].ruleList = []
            $scope.param.alarmRulesetList[$scope.ruleTab].alarmCondition.forEach((condition) => {
                condition.fieldList.forEach((item) => {
                    item.selected = false
                })
            })
        }

        $scope.fieldCodeChange = function fieldCodeChange(item, field) {
            item.ruleList = item.ruleList || []
            if (field.selected) {
                field.fieldValueList.forEach((fieldValue) => {
                    fieldValue.selected = false
                })
                item.ruleList.push(makeFieldRule({}, field))
            } else {
                item.ruleList = item.ruleList.filter((rule) => {
                    if (rule.fieldCode === field.fieldCode) {
                        return false
                    }
                    return true
                })
            }
        }
        // field = alarmRulesetList[i].alarmCondition.fieldList[j]
        // item = alarmRulesetList[i]
        makeFieldRule = function makeFieldRule1(fieldRule, condition) {
            let dicCompareArr
            let dicCompareType
            if (condition.remark) {
                dicCompareArr = condition.remark.split(',')
                dicCompareType = $scope.dictData.compare_type.filter((item) => {
                    if (dicCompareArr.indexOf(item.enumCode) > -1) {
                        return item
                    }
                    return false
                })
            }
            // if (dicCompareType.length === 1) {
            // fieldRule.compareType = dicCompareType[0].enumCode
            // }
            fieldRule.refText = 0
            const defaultValueArr = []
            condition.fieldValueList.forEach((fieldValue) => {
                // 设置默认值
                if (!fieldRule.refValue && fieldValue.defaultFlag) {
                    fieldRule.refText += 1
                    fieldValue.selected = true
                    defaultValueArr.push(fieldValue.key)
                } else {
                    // 有些值是数字
                    const valueList = `${fieldRule.refValue}`.split(',')
                    valueList.forEach((value) => {
                        // 临时修改不要使用恒等号
                        if (fieldValue.key == value) {
                            fieldRule.refText += 1
                            fieldValue.selected = true
                        }
                    })
                    if (fieldRule.refText === condition.fieldValueList.length) {
                        fieldRule.allSelected = true
                    }
                }
            })
            fieldRule.refValue = defaultValueArr.length > 0 ? defaultValueArr.join(',') : fieldRule.refValue
            // 只有一个候选值直接赋值
            if (condition.fieldValueList.length === 1) {
                fieldRule.refValue = fieldRule.refValue || `${condition.fieldValueList[0].key}`
            }
            return {
                compareType: '',
                ...fieldRule,
                dicCompareType,
                dataType: condition.dataType,
                fieldCode: condition.fieldCode,
                fieldName: condition.fieldName,
                fieldValueList: condition.fieldValueList,
                description: condition.description,
                unit: condition.unit,
            }
        }
        $scope.selectAll = function selectAll(rule) {
            rule.allSelected = !rule.allSelected
            const { fieldValueList } = rule
            fieldValueList.forEach((filedRule) => {
                filedRule.selected = rule.allSelected
            })
            if (rule.allSelected) {
                rule.refText = fieldValueList.length
                rule.refValue = fieldValueList.map((item) => item.key).join(',')
            } else {
                rule.refText = 0
                rule.refValue = ''
            }
        }
        $scope.selectAll = function selectAll(rule) {
            rule.allSelected = !rule.allSelected
            const { fieldValueList } = rule
            fieldValueList.forEach((filedRule) => {
                filedRule.selected = rule.allSelected
            })
            if (rule.allSelected) {
                rule.refText = fieldValueList.length
                rule.refValue = fieldValueList.map((item) => item.key).join(',')
            } else {
                rule.refText = 0
                rule.refValue = ''
            }
        }

        // 添加告警
        $scope.operatedAdd = function () {
            const alarmRulesetListLen = $scope.param.alarmRulesetList.length
            const index = alarmRulesetListLen + 1
            if (alarmRulesetListLen >= 10) {
                logger.logError('最多支持添加10个告警集')
                return
            }
            $scope.param.alarmRulesetList.push({
                kpiObject: alarmCondition[0].kpiObject,
                ruleList: [],
                rulesetName: `告警${index}`,
                alarmCondition: deepCopy(alarmCondition),
            })
            $scope.alarmRulesetListLength = $scope.param.alarmRulesetList.length
        }

        $scope.fieldValueListHover = function (row, flag) {
            row.mouseenter = flag
        }

        $scope.selectFieldValue = function (fieldValue, rule) {
            fieldValue.selected = !fieldValue.selected
            const selectedArr = rule.fieldValueList.filter((item) => item.selected)
            const selectedIdArr = selectedArr.map((item) => item.key)
            rule.refText = selectedIdArr.length
            if (rule.refText === rule.fieldValueList.length) {
                rule.allSelected = true
            } else {
                rule.allSelected = false
            }
            rule.refValue = selectedIdArr.join(',')
        }
        // 选中当前告警
        $scope.prewarnRuleFocus = function (item, $index) {
            $scope.ruleTab = $index
        }

        // 当前告警名称变化
        $scope.prewarnRuleChange = function (item, $index) {
            if (lengthForString(item.rulesetName) > 10) {
                item.rulesetName = ''
                logger.logError('告警名称最多10个字符')
            }
        }

        // 删除告警
        $scope.operatedMinus = function ($index) {
            const alarmRulesetListLen = $scope.param.alarmRulesetList.length
            if (alarmRulesetListLen <= 1) {
                logger.logError('至少要保留1个告警集')
                return
            }
            $scope.param.alarmRulesetList.splice($index, 1)
            $scope.alarmRulesetListLength = $scope.param.alarmRulesetList.length
        }

        // 通知人员
        $scope.informPersonList = []

        // 选择通知人员
        $scope.choosePerson = function () {
            // 弹窗
            const choosePersonModalData = $scope.param.notifierList // 数据
            const modalInstance = $uibModal.open({
                template: choosePersonPage,
                controller: 'choosePersonCtrl',
                backdrop: 'static',
                openedClass: 'mod-modal-chooseperson mod-modal mod-modal-lg',
                resolve: {
                    items1() {
                        return choosePersonModalData
                    },
                },
            })
            modalInstance.result.then((item) => {
                console.log(`output->`,item)
                const _selectedListArr = toNotifierData(item.selectedList, 'realName')
                console.log(`output->`,_selectedListArr)
                $scope.param.notifierList = _selectedListArr
            })
        }
        /**
         * 返回字符串的长度--中文占2个字符
         * @param temp
         * @returns
         */
        function lengthForString(temp) {
            let len = 0
            temp = $.trim(temp)
            for (let i = 0; i < temp.length; i++) {
                const c = temp.charCodeAt(i)
                // 单字节加1
                if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
                    len++
                } else {
                    len += 2
                }
            }
            return len
        }

        // 转换通知人员字段
        function toNotifierData(list, textfield) {
            const result = []
            list.forEach(el => {
                const tempdata = {
                    objectName: '',
                }
                tempdata.objectName = el.userName
                tempdata[textfield] = el[textfield]
                result.push(tempdata)
            });
            // for (const a in list) {
            //     const tempdata = {
            //         objectName: '',
            //     }
            //     tempdata.objectName = list[a].userName
            //     tempdata[textfield] = list[a][textfield]
            //     result.push(tempdata)
            // }
            return result
        }

        // 删除通知人员
        $scope.delInformPerson = function ($index) {
            $scope.param.notifierList.splice($index, 1)
        }

        // 表格行划过
        $scope.tb_rowhover = function (row, flag) {
            row.mouseenter = flag
        }

        // noticeInterval
        $scope.noticeIntervalChange = function () {
            if ($scope.param.noticeInterval === '') {
                return
            }
            if ($scope.param.noticeInterval > 744) {
                $scope.param.noticeInterval = ''
                logger.logError('通知间隔时间不能大于744小时')
                return
            }
            if (!/^[1-9]\d*$/.test($scope.param.noticeInterval) || $scope.param.noticeInterval == 0) {
                logger.logError('通知间隔时间为正整数')
                $scope.param.noticeInterval = ''
            }
        }
        // rulevalue change
        $scope.refValueChange = function (item) {
            // 为空时不提示
            if (!item.refValue) {
                return
            }
            // number
            if (item.dataType === '3') {
                if (!/^[1-9]\d*$/.test(item.refValue)) {
                    logger.logError('数量为正整数')
                    item.refValue = ''
                    return
                }
            }
            // percent
            if (item.dataType === '2') {
                if (!isPnumReg.test(item.refValue) || item.refValue <= 0) {
                    logger.logError('占比为正整数比值必须小于100%')
                    item.refValue = ''
                }
            }
        }

        $scope.submit = function () {
            // 通知方式校验
            if ($scope.param.noticeType === '') {
                logger.logError('请至少选择一种通知方式')
                return false
            }
            // 通知间隔时间
            if (globalFn.isNullVal($scope.param.noticeInterval)) {
                logger.logError('通知间隔时间不能为空')
                return false
            }
            if ($scope.param.noticeInterval > 744) {
                return logger.logError('通知间隔时间不能大于744小时')
            }
            // 通知人员限制条件
            if ($scope.param.notifierList.length === 0) {
                logger.logError('通知人员不能为空')
                return false
            }
            // 规则校验
            for (let i = 0, l = $scope.param.alarmRulesetList.length; i < l; i++) {
                const _alarmRulesetList = $scope.param.alarmRulesetList[i]
                const _kpiObject = _alarmRulesetList.kpiObject
                const ruleListLen = _alarmRulesetList.ruleList.length
                const index = i + 1
                const invoiceStockAlarmSelContent = {
                    11: '开票点',
                    12: '服务器',
                    13: '机构名称',
                    14: '企业名称',
                }
                let invoiceStockAlarmSelFlag = false
                let invoiceStockAlarmSelTitle
                // 校验规则
                // 规则名称有效性
                if (_alarmRulesetList.rulesetName === '') {
                    logger.logError(`第${index}预警条件名称名称不能为空`)
                    return false
                }
                if (ruleListLen === 0) {
                    logger.logError('请选择预警规则')
                    return false
                }
                for (let a = 0; a < ruleListLen; a++) {
                    const _ruleList = _alarmRulesetList.ruleList[a]
                    // 判断规则
                    if (!_ruleList.compareType) {
                        logger.logError(`${_alarmRulesetList.rulesetName}的${_ruleList.fieldName}比较类型不能为空`)
                        return false
                    }
                    if (!_ruleList.refValue) {
                        logger.logError(`${_alarmRulesetList.rulesetName}的${_ruleList.fieldName}参考值不能为空`)
                        return false
                    }
                    // 机构取当前机构

                    // 库存预警唯一必选项校验
                    if ($scope.param.pointCode === 'invoice_stock_alarm') {
                        invoiceStockAlarmSelTitle = _alarmRulesetList.rulesetName
                        if (['disk_id', 'ukey_id', 'sale_id', 'invoice_org_id'].indexOf(_ruleList.fieldCode) > -1) {
                            invoiceStockAlarmSelFlag = true
                        }
                    }
                }
                if ($scope.param.pointCode === 'invoice_stock_alarm') {
                    if (!invoiceStockAlarmSelFlag) {
                        logger.logError(` ${invoiceStockAlarmSelTitle} 中，${invoiceStockAlarmSelContent[`${_alarmRulesetList.kpiObject}`]} 规则为必选项`)
                        return false
                    }
                }
                // 库存预警必选其一校验
                if ($scope.param.pointCode === 'invoice_stock_alarm') {
                    if (ruleListLen < 2) {
                        // 已满足库存预警唯一必选项校验后，length至少为2才符合校验
                        logger.logError(` ${invoiceStockAlarmSelTitle} 中，专用发票、普通发票、电子发票、卷式发票、机动车发票、二手车发票 规则必选其一`)
                        return false
                    }
                }
            }
            httpRequest.post_settingAlarm($scope.param).then((res) => {
                if (res.data.success) {
                    logger.logSuccess('修改成功')
                    $state.go('system.settingcenter.preWarn.list')
                }
            })
            return false
        }

        $scope.cancel = function () {
            $state.go('system.settingcenter.preWarn.list')
            return false
        }
    }
}

preWarnSettingCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$state', 'globalFn']
export default preWarnSettingCtrl



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/preWarn/preWarnSettingCtrl.js